import React, { useEffect, useState } from "react";

export const DEFAULT_AVATAR = "/avatars/default.svg";
const RETRY_DELAYS = [2000, 4000, 8000];
const isApiAvatar = (src) => typeof src === "string" && src.includes("/api/b2c/avatar/");

// Avatar <img>: never shows a broken image. API avatars are fetched so a storage
// fallback (X-Avatar-Fallback) or error shows the findloop default silhouette, then the
// real avatar is retried silently in the background (2 s, 4 s, 8 s).
export const AvatarImg = ({ src, alt = "", className, ...rest }) => {
  const [shown, setShown] = useState(isApiAvatar(src) ? DEFAULT_AVATAR : src || DEFAULT_AVATAR);

  useEffect(() => {
    if (!isApiAvatar(src)) { setShown(src || DEFAULT_AVATAR); return undefined; }
    let cancelled = false;
    let timer = null;
    let objectUrl = null;
    const load = async (attempt) => {
      try {
        const res = await fetch(attempt ? `${src}${src.includes("?") ? "&" : "?"}r=${attempt}` : src);
        if (!res.ok || res.headers.get("X-Avatar-Fallback")) throw new Error(String(res.status));
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setShown(objectUrl);
      } catch {
        if (cancelled) return;
        setShown(DEFAULT_AVATAR);
        if (attempt < RETRY_DELAYS.length) timer = setTimeout(() => load(attempt + 1), RETRY_DELAYS[attempt]);
      }
    };
    load(0);
    return () => { cancelled = true; clearTimeout(timer); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src]);

  return <img src={shown} alt={alt} className={className} onError={() => setShown(DEFAULT_AVATAR)} {...rest} />;
};
